module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "胰岛素数据统计"
    }
  }, [_c('HCLTable', {
    staticStyle: {
      "margin-top": "13px"
    },
    attrs: {
      "tableData": _vm.InsulinDataList,
      "tabType": _vm.insulinData,
      "pagesize": _vm.pagesize,
      "loading": _vm.loading
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06a9cb49"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountAdmin/dataSTS/insulinStatistics.vue
// module id = 1411
// module chunks = 7